(function ($, Drupal) {
  Drupal.behaviors.factListing = {
    attach: function (context, settings) {
      $(once('init-block-fact-listing', '.block-fact-listing', context))
        .each(function () {
          const contentFactListing = $(this);
          const contentFactListingSelector = contentFactListing.find(
            '.swiper-container',
            context
          );
          if (contentFactListingSelector.length) {
            let sliderOptions = {
              loop: false,
              pagination: {
                el: '.swiper-pagination',
              },
              // Responsive breakpoints
              breakpoints: {
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              },
            };

            // First thing we need to fetch slider settings from data attributes.
            new Swiper(contentFactListingSelector[0], sliderOptions);
          }
        });
    },
  };
})(jQuery, Drupal);
